import { Fingerprint } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FingerprintIcon = createLucideIcon(Fingerprint);
